import RetailCollection from 'app/src/data/models/RetailCollection';
import UITooltip from 'app/src/data/models/UITooltip';
import URLHelper from 'app/src/data/models/utils/URLHelper';

export default class UITooltipCollection extends RetailCollection {
  get model() {
    return UITooltip;
  }

  /**
   * Return the REST url for collection of Shop models
   * @returns {string} the url representing the REST endpoint
   */
  url() {
    return URLHelper.getAccountURL('/UITooltip.json');
  }

  /**
   * Overridden to parse out superfluous json that the current LSCloud returns us
   * @param response
   * @returns {*}
   */
  parse(response) {
    // response.UserPreference is an array of the UserPreference structures we want.
    // Return it directly if an object is found; otherwise return an empty array and let
    // Backbone handle it
    return response.UserPreference || [];
  }
}
